import _styled, { default as _styled2, default as _styled3 } from "styled-components";
/* eslint-disable jsx-a11y/label-has-associated-control */
var _templateObject, _templateObject2;
var _excluded = ["className", "error", "label", "textSize"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { Checkbox } from "../Checkbox/Checkbox";
import * as styles from "./CheckboxWithLabel.styles";
import { fieldFeedbackContainer } from "../../FieldWrapper/FieldWrapper.styles";
import { Feedback } from "../../Feedback/Feedback";
var text = theme.text;
var DEFAULT_TEXT_SIZE = 'MD';
export var CheckboxWithLabel = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var className = _ref.className,
    error = _ref.error,
    label = _ref.label,
    _ref$textSize = _ref.textSize,
    textSize = _ref$textSize === void 0 ? DEFAULT_TEXT_SIZE : _ref$textSize,
    props = _objectWithoutProperties(_ref, _excluded);
  var errorId = error ? "".concat(props.name || '', "-error") : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledLabel, {
    className: className,
    ref: forwardedRef,
    $_css: [styles.checkboxLabel, props.disabled && styles.checkboxLabelDisabled]
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, props, {
    "aria-describedby": errorId,
    "aria-invalid": !!error
  })), /*#__PURE__*/React.createElement(_StyledSpan, {
    dangerouslySetInnerHTML: {
      __html: label
    },
    $_css2: [styles.checkboxLabelText, fontSize(text.BODY[textSize])]
  })), error && /*#__PURE__*/React.createElement(_StyledDiv, {
    role: "alert",
    $_css3: [fieldFeedbackContainer, styles.checkboxErrorMessage]
  }, /*#__PURE__*/React.createElement(Feedback, {
    error: true,
    iconAlign: "left",
    id: errorId,
    name: error
  })));
});
var _StyledLabel = _styled("label")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan = _styled2("span")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "CheckboxWithLabel___StyledDiv",
  componentId: "sc-adcxol-0"
})(["", ""], function (p) {
  return p.$_css3;
});